import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface PlatformAnalytics {
  totals: {
    tenants: number;
    activeTenants: number;
    suspendedTenants: number;
    users: number;
    activeUsers: number;
  };
  byPlan: { plan: string; count: number }[];
  recentTenants: { id: string; name: string; slug: string; isActive: boolean; createdAt?: string }[];
}

export const getPlatformAnalytics = () =>
  axios.get<PlatformAnalytics>(`${API_V1}/platform/analytics`).then((r) => r.data);

export interface GrowthPoint {
  month: string; // YYYY-MM
  count: number; // new that month
  cumulative: number; // running total
}
export interface PlatformGrowth {
  tenantsByMonth: GrowthPoint[];
  usersByMonth: GrowthPoint[];
}
export const getPlatformGrowth = () =>
  axios.get<PlatformGrowth>(`${API_V1}/platform/analytics/growth`).then((r) => r.data);

export interface ServiceHealth {
  name: string;
  status: 'up' | 'down' | 'unknown';
  responseMs: number;
  version?: string | null;
  category?: 'backend' | 'frontend' | 'mobile';
}
// Gateway-aggregated health across every backend + the public frontends + mobile.
// The gateway owns the verified internal URLs, so this reflects real reachability.
export const getPlatformHealth = () =>
  axios.get<{ services: ServiceHealth[] }>(`${API_V1}/platform/service-health`).then((r) => r.data);

export interface PlatformSecurity {
  totals: {
    activeUsers: number;
    mfaEnabled: number;
    mfaAdoptionPct: number;
    lockedAccounts: number;
    usersWithFailedAttempts: number;
    totalFailedAttempts: number;
    activeSessions: number;
    logins24h: number;
  };
  lockedAccounts: {
    email: string;
    tenant: string | null;
    lockedUntil: string | null;
    failedAttempts: number;
    lastIp: string | null;
  }[];
  recentEvents: {
    action: string;
    who: string | null;
    tenant: string | null;
    ip: string | null;
    statusCode: number | null;
    at: string | null;
  }[];
}

export const getPlatformSecurity = () =>
  axios.get<PlatformSecurity>(`${API_V1}/platform/security`).then((r) => r.data);
